import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';

export const quickDepositSelector = createSelector(betslipSelector, (state) => state.quickDeposit);
export const selectQuickDepositIsOpen = createSelector(quickDepositSelector, (state) => state.isOpen || state.isAvailable);
export const selectQuickDepositSelectedPaymentMethod = createSelector(quickDepositSelector, (state) => state.selectedpaymentMethod);
